import { Link } from 'react-router-dom'
import { useApp } from '../context/AppContext'
import MainLayout from '../layouts/MainLayout'
import HelpCenter from '../pages/HelpCenter'
import IconoMecsa from '../assets/icon-mecsa-proyectos.svg'

/**
 * Ruta pública del Centro de Ayuda.
 *
 * La guía de usuario es de acceso público: cualquier persona puede consultarla
 * sin iniciar sesión.
 *
 * - Si hay una sesión activa, se muestra dentro del layout principal
 *   (con Sidebar y Topbar), igual que el resto de la aplicación.
 * - Si no hay sesión, se muestra en un layout público sencillo con el logo
 *   y un acceso para iniciar sesión.
 *
 * @component
 * @returns {JSX.Element}
 */
const HelpRoute = () => {
  const { user } = useApp()

  if (user) {
    return (
      <MainLayout>
        <HelpCenter />
      </MainLayout>
    )
  }

  return (
    <div
      className="min-vh-100 d-flex flex-column"
      style={{ background: 'var(--bg-app)', color: 'var(--text)' }}
    >
      {/* Barra superior pública, con el mismo aire que el topbar de la app */}
      <header className="cms-topbar">
        <div className="topbar-left">
          <span className="help-public-mark">
            <img src={IconoMecsa} alt="" />
          </span>
          <nav className="topbar-breadcrumb">
            <span className="bc-link">Grupo Mecsa</span>
            <i className="fas fa-chevron-right bc-sep"></i>
            <span className="bc-current">Sistema de Tickets</span>
          </nav>
        </div>
        <div className="topbar-search"></div>
        <div className="topbar-right">
          <Link to="/login" className="btn btn-gm-primary btn-sm">
            <i className="fa-solid fa-right-to-bracket me-1"></i>
            Iniciar sesión
          </Link>
        </div>
      </header>

      {/* Contenido de la guía */}
      <main className="flex-grow-1 p-3 p-lg-4">
        <HelpCenter />
      </main>
    </div>
  )
}

export default HelpRoute
